import React from 'react';
import { useGetStarted } from './GetStartedContext';
import { TutorialStep } from './types';
import { questLogo } from '../../../../assets/images';
import General from '../../../../general';
import GetStartedSvgs from '../components/GetStartedSvgs';
import { PrimaryButton } from '../../../../components/Modules/PrimaryButton';
import { SecondaryButton } from '../../../../components/Modules/SecondaryButton';

interface CardProps {
  data: TutorialStep;
  index: number;
  isLast: boolean;
}

const Card: React.FC<CardProps> = ({ data, index, isLast }) => {
  const {
    template,
    themeManager,
    handleCriteriaClick,
    dropdowns,
    setDropdown,
    isImageOpen,
    iconUrls,
    ButtonType,
    allowMultiClick
  } = useGetStarted();

  const GeneralFunctions = new General("mixpanel", "production");

  const handleDropdownToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDropdown(prev => prev.map((item, i) => i === index ? !item : item));
  };

  if (template === 2) {
    return (
      <div
        className="gs-single-card-dropDown"
        style={{ ...themeManager.getCardStyles().card, borderRadius: themeManager.getBorderRadius() }}
        onClick={handleDropdownToggle}
      >
        <div className="gs_card_body_dropDown">
          {(!dropdowns[index] || !isImageOpen) && (
            <div
              className="gs_card_body_image"
              style={themeManager.getCardStyles(1, data.imageUrl || iconUrls?.[index]).icon}
            >
              {(data.imageUrl || iconUrls?.[index]) ? <img
                className="gs-card-icon"
                src={data.imageUrl || iconUrls?.[index]}
                alt=""
              /> : <p className='gs-card-number' style={{ color: themeManager.getCardStyles(1, data.imageUrl || iconUrls?.[index]).icon?.background === "#f4ebff" ? "black" : "white" }}>{index + 1}</p>}
            </div>
          )}

          <div className="gs-card-text">
            <div style={themeManager.getHeadingStyles()} className="gs-card-head">
              {data.title}
            </div>
            <div style={themeManager.getDescriptionStyles()} className="gs-card-desc">
              {data.description}
            </div>
          </div>

          <div className="gs-card-img-button">
            {data.completed ? (
              <div
                className="q_gt_arrow-completed"
                style={{
                  background: themeManager.getArrowStyles(true).background
                }}
              >
                <GetStartedSvgs
                  type="greenCheck"
                  color={themeManager.getArrowStyles(true).iconColor}
                />
              </div>
            ) : (
              <div
                className="q_gt_arrow"
                style={{
                  background: themeManager.getArrowStyles(false).background
                }}
              >
                <GetStartedSvgs
                  type={dropdowns[index] ? "upArrow" : "downArrowIcon"}
                  color={themeManager.getArrowStyles(false).iconColor}
                />
              </div>
            )}
          </div>
        </div>

        {dropdowns[index] && (
          <div className="gs_card_dropdown">
            {isImageOpen && (
              <div
                className="card-drop-down-cont"
                style={
                  themeManager.getStyleValueAsObject("IsImageOpen.ContainerDiv", { background: themeManager.getCardStyles().icon?.background })
                }
              >
                <div
                  style={themeManager.getStyleValueAsObject(
                    "IsImageOpen.ImageContainer.ImageContainerProperties",
                    {}
                  )}
                >
                  <img
                    src={data?.imageUrl || iconUrls?.[index]}
                    alt=""
                    style={{
                      borderRadius: themeManager.getStyleValueAsString(
                        "IsImageOpen.ImageContainer.Image.borderRadius",
                        "50%"
                      ),
                      ...themeManager.getStyleValueAsObject(
                        "IsImageOpen.ImageContainer.Image",
                        {}
                      ),
                    }}
                  />
                </div>
              </div>
            )}
            <div
              className="gs_drop_desc"
              style={themeManager.getDescriptionStyles()}
            >
              {data.longDescription}
            </div>
            <div className="gs_drop_btns">
              <PrimaryButton
                attr={data.url}
                className="gs_start_btn"
                data-primary-button={data.url}
                onClick={(event) => {
                  event.stopPropagation();
                  GeneralFunctions.fireTrackingEvent(
                    "quest_get_started_primary_button_clicked",
                    "get_started"
                  );
                  if (!(!allowMultiClick && data.completed)) {
                    handleCriteriaClick(data, data.url);
                  }
                }}
                disabled={!allowMultiClick && data.completed}
                style={{
                  ...themeManager.getButtonStyles().primary,
                  width: "fit-content",
                  border: "none"
                }}
              >
                {data.btn2 || "Start Now"}
              </PrimaryButton>
              <SecondaryButton
                style={{
                  ...themeManager.getButtonStyles().secondary,
                  width: "fit-content",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  GeneralFunctions.fireTrackingEvent(
                    "quest_get_started_secondary_button_clicked",
                    "get_started"
                  );
                  window.open(data.btn1Link);
                }}
                className="gs_visit_btn"
              >
                {data.btn1 || "Visit Website"}
              </SecondaryButton>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Template 1
  return (
    <div
      className="gs-single-card"
      data-primary-button={data.url}
      onClick={() => {
        if (!(!allowMultiClick && data.completed)) {
          handleCriteriaClick(data, data.url);
        }
      }}
    >
      <div className="gs_card_body" style={{ ...themeManager.getCardStyles().card, borderRadius: themeManager.getBorderRadius() }}>
        <div
          className="gs_card_body_image"
          style={themeManager.getCardStyles(1, data.imageUrl || iconUrls?.[index]).icon}
        >
          {(data.imageUrl || iconUrls?.[index]) ? <img
            className="gs-card-icon"
            src={data.imageUrl || iconUrls?.[index]}
            alt=""
          /> : <p className='gs-card-number' style={{ color: themeManager.getCardStyles(1, data.imageUrl || iconUrls?.[index]).icon?.background === "#f4ebff" ? "black" : "white" }}>{index + 1}</p>}
        </div>
        <div className="gs-card-text">
          <div style={themeManager.getHeadingStyles()} className="gs-card-head">
            {data.title}
          </div>
          <div style={themeManager.getDescriptionStyles()} className="gs-card-desc">
            {data.description}
          </div>
        </div>

        {ButtonType === "Buttons" ? (
          !data.completed ? (
            <div className="gs_drop_btns">
              <SecondaryButton
                style={{
                  ...themeManager.getButtonStyles().secondary,
                  border: "none",
                  width: "fit-content",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  GeneralFunctions.fireTrackingEvent(
                    "quest_get_started_secondary_button_clicked",
                    "get_started"
                  );
                  window.open(data.btn1Link);
                }}
                className="gs_visit_btn gs_tempalate1_btn"
              >
                {data.btn1 || "Visit Website"}
              </SecondaryButton>
              <PrimaryButton
                attr={data.url}
                className="gs_start_btn"
                data-primary-button={data.url}
                onClick={(event) => {
                  event.stopPropagation();
                  GeneralFunctions.fireTrackingEvent(
                    "quest_get_started_primary_button_clicked",
                    "get_started"
                  );
                  if (!(!allowMultiClick && data.completed)) {
                    handleCriteriaClick(data, data.url);
                  }
                }}
                disabled={!allowMultiClick && data.completed}
                style={{
                  ...themeManager.getButtonStyles().primary,
                  width: "fit-content",
                }}
              >
                {data.btn2 || "Start Now"}
              </PrimaryButton>
            </div>
          ) : (
            <div className="gs-card-img-button">
              <div
                className="q_gt_arrow-completed"
                style={{
                  background: themeManager.getArrowStyles(true).background,
                }}
              >
                <GetStartedSvgs
                  type="greenCheck"
                  color={themeManager.getArrowStyles(true).iconColor}
                />
              </div>
            </div>
          )
        ) : (
          <div className="gs-card-img-button">
            {data.completed ? (
              <div
                className="q_gt_arrow-completed"
                style={{
                  background: themeManager.getArrowStyles(true).background,
                }}
              >
                <GetStartedSvgs
                  type="greenCheck"
                  color={themeManager.getArrowStyles(true).iconColor}
                />
              </div>
            ) : (
              <div
                className="q_gt_arrow"
                style={{
                  background: themeManager.getArrowStyles(false).background,
                }}
              >
                <GetStartedSvgs
                  type="arrowRight"
                  color={themeManager.getArrowStyles(false).iconColor}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card